export default function problemTab() {
  const tabButtons = document.querySelectorAll(".p-topProblemTab__name button");
  const tabSections = document.querySelectorAll(".p-topProblemTab__section");

  tabButtons.forEach(function(button) {
    button.addEventListener("click", function() {
      // 選択されたタブのボタンをアクティブにし、他のタブのボタンを非アクティブにする
      tabButtons.forEach(function(btn) {
        btn.setAttribute("aria-selected", "false");
      });
      this.setAttribute("aria-selected", "true");

      // 選択されたタブのコンテンツを表示し、他のタブのコンテンツを非表示にする
      const target = this.getAttribute("aria-controls");
      tabSections.forEach(function(section) {
        if (section.id === target) {
          section.setAttribute("aria-hidden", "false");
        } else {
          section.setAttribute("aria-hidden", "true");
        }
      });
    });
  });
}
